import { create } from "zustand";

// Raw-string key (not zustand/persist) on purpose: src/main.tsx reads this
// key synchronously before React mounts to set the .dark class without a
// flash — keep the two in sync if this ever changes.
const THEME_KEY = "secret-missions-theme";

export type Theme = "dark" | "light";

interface UiStore {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useUiStore = create<UiStore>()((set) => ({
  theme: (localStorage.getItem(THEME_KEY) as Theme) || "dark",
  setTheme: (theme) => {
    localStorage.setItem(THEME_KEY, theme);
    document.documentElement.classList.toggle("dark", theme === "dark");
    set({ theme });
  },
}));
